import { meetingStatuses } from "@/constants/meeting.js";

// FIXME: renounced (DEV-3964)
export default {
  createMandatesForBuildingOwner(buildingOwner) {
    let MeetingDB = require("./models/Meeting");
    new MeetingDB()
      .query(qb => {
        qb.where("building_id", "=", buildingOwner.building_id)
          .where("status", "!=", meetingStatuses.completed)
          .where("status", "!=", meetingStatuses.canceled)
          .whereNull("deleted");
      })
      .fetchAll()
      .then(res => {
        var meetings = res.serialize();

        let MandateDB = require("./models/Mandate");
        meetings.forEach(meeting => {
          var mandate = {
            agency_id: buildingOwner.agency_id,
            building_owner_id: buildingOwner.id,
            representant_owner_id: buildingOwner.id,
            meeting_id: meeting.id,
            voted_by_correspondence: 0,
            showed_up: 0,
          };
          new MandateDB(mandate)
            .save()
            .then(res => {})
            .catch(err => {
              console.error("create mandate", err);
            });
        });
      })
      .catch(err => {
        console.err("get meetings", err);
      });
  },
  createMandatesForMeeting(meeting) {
    return new Promise((resolve, reject) => {
      let BuildingOwnerDB = require("./models/BuildingOwner");
      new BuildingOwnerDB()
        .query(qb => {
          qb.where("building_id", "=", meeting.building_id).whereNull("deleted");
        })
        .fetchAll({ require: false })
        .then(res => {
          var buildingOwners = res.serialize() ? res.serialize() : [];
          var totalBuildingOwners = buildingOwners.length;

          // NOTE: check all created mandates
          //       set countMandatesCreated equal to nb of already created mandates
          //       then create mandate for building owner only if not already created

          let MandateDB = require("./models/Mandate");
          new MandateDB()
            .query(qb => {
              qb.where("meeting_id", "=", meeting.id).whereNull("deleted");
            })
            .fetchAll({ require: false })
            .then(async res => {
              var existingMandates = res.serialize() ? res.serialize() : [];
              var countMandatesCreated = existingMandates.length; // set meeting status only if countMandatesCreated == totalBuildingOwners

              for (const buildingOwner of buildingOwners) {
                if (totalBuildingOwners == countMandatesCreated) break;

                let foundMandate = existingMandates.find(
                  mandate => mandate.building_owner_id == buildingOwner.id
                );
                if (!foundMandate) {
                  var mandate = {
                    agency_id: buildingOwner.agency_id,
                    building_owner_id: buildingOwner.id,
                    meeting_id: meeting.id,

                    representant_contact_id: null,
                    representant_owner_id: buildingOwner.id,

                    voted_by_correspondence: 0,
                    showed_up: 0,
                  };
                  await new MandateDB(mandate)
                    .save()
                    .then(res => {
                      console.log("Mandate created");
                      countMandatesCreated++;
                    })
                    .catch(err => {
                      console.error("create mandate", err);
                      reject(err);
                    });
                }
              }

              if (totalBuildingOwners == countMandatesCreated) {
                console.log("after all mandates are created");
                let MeetingDB = require("./models/Meeting");
                new MeetingDB(meeting)
                  .save({ status: meetingStatuses.mandatesCreated }, { patch: true })
                  .then(res => {
                    console.log("meeting", res);
                    var data = res.serialize();
                    var MeetingORM = require("../store/orm-axios/models/Meeting").default;
                    MeetingORM.insertOrUpdate({
                      data: data,
                    });
                    resolve("done");
                  })
                  .catch(err => {
                    console.error("update meeting", err);
                    reject(err);
                  });
              }
            })
            .catch(err => {
              console.error("get mandates", err);
              reject(err);
            });
        })
        .catch(err => {
          console.error("get building owners", err);
          reject(err);
        });
    });
  },
};
